<div class="nav-bar">
  <img src="../../../../assets/svg/logo.svg" alt="Logo" />
</div>

<div class="confirm-email-wrapper">
  <div class="confirm-email-card" *ngIf="!navigating">
    <div class="header">
      <h3>Forgot password</h3>
      <p>We’ll send a password reset link to this email, if it matches an existing BizLab account.</p>
    </div>
    <form [formGroup]="form" class="flex flex-col gap-4">
      <flow-form-input
        type="email"
        label="Email"
        placeholder="Email"
        formControlName="email"
        id="email"
      />

      <flow-button theme="primary" variation="fill" type="button" [fullWidth]="true" [disabled]="loadingCE" (onClick)="onConfirmEmail()">
        Confirm
      </flow-button>
      <flow-button theme="secondary" variation="outline" type="button" [fullWidth]="true" [routerLink]="['/login']">Back</flow-button>
    </form>
  </div>

  <div class="footer">© BizLab Analytics {{currentYear}}</div>
</div>
